var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"sidebar"},[_c('card'),_c('list')],1),_c('div',{staticClass:"main"},[_c('message'),_c('usertext')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }